import { render } from "./Appointment.vue?vue&type=template&id=c9d71c9c&scoped=true"
import script from "./Appointment.vue?vue&type=script&lang=ts"
export * from "./Appointment.vue?vue&type=script&lang=ts"

import "./Appointment.vue?vue&type=style&index=0&id=c9d71c9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c9d71c9c"

export default script